import { NgModule } from "@angular/core";
import { BarChartComponent } from "./bar-chart/bar-chart.component";
import { BubbleChartComponent } from "./bubble-chart/bubble-chart.component";
import { LineChartComponent } from "./line-chart/line-chart.component";
import { PieChartComponent } from "./pie-chart/pie-chart.component";
import { RadarChartComponent } from "./radar-chart/radar-chart.component";
import { LegendComponent } from "./legend.component";
import { BaseChartDirective } from "ng2-charts";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { Treemap } from "./treemap/treemap.component";

@NgModule({
    declarations: [
        BarChartComponent,
        BubbleChartComponent,
        LineChartComponent,
        PieChartComponent,
        RadarChartComponent,
        LegendComponent,
        Treemap
    ],
    exports: [
        BarChartComponent,
        BubbleChartComponent,
        LineChartComponent,
        PieChartComponent,
        RadarChartComponent,
        LegendComponent,
        Treemap
    ],
  imports: [
        BaseChartDirective,
        CurrencyPipe, 
        DecimalPipe
    ],
    providers: [
    ]
})
export class ChartsModule { }